import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, isUndefined, isArray, find } from 'lodash';
import { AlertNotice, ModalInfo, AlertMessage } from 'shared/components';
import { filterCapacityTypesByUnlimited } from './../selectors';
import * as requestUpdateActions from 'features/request-update/duck';
import { ReviewRescheduleTC } from 'features/request-update/index';
import {
  REQUEST_UPDATE_TYPE,
  REQUEST_UPDATE_STATUS,
  LOCATION_EVENT_STATUS,
} from 'shared/constants';
import CloseCircle from 'assets/svgs/closeCircle.svg';
import { SHIPPING_LABELS } from '../constants';
import { mapCapacityTypes } from 'shared/helpers';
import BuildingIcon from 'assets/svgs/buildingIconBlack.svg';
import './CancelRequestUpdate.scss';

const getAlertMessage = (type) => {
  switch (type) {
    case REQUEST_UPDATE_TYPE.eventUpdate:
      return 'requestUpdate.cancelRequest.successEventUpdate';
    case REQUEST_UPDATE_TYPE.closeTcEvent:
      return 'requestUpdate.cancelRequest.successCloseTcEvent';
    case REQUEST_UPDATE_TYPE.rescheduleTcEvent:
      return 'requestUpdate.cancelRequest.successRescheduleTcEvent';
    default:
      return '';
  }
};
class CancelRequestUpdate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cancelModalOpen: false,
      alertMessage: '',
      showAlertMessage: false,
    };

    this.toggleCancelModal = this.toggleCancelModal.bind(this);
    this.onCancelRequest = this.onCancelRequest.bind(this);
    this.removeAlertMessage = this.removeAlertMessage.bind(this);
    this.renderRequest = this.renderRequest.bind(this);
  }

  toggleCancelModal() {
    this.setState((prevState) => ({
      cancelModalOpen: !prevState.cancelModalOpen,
    }));
  }

  async onCancelRequest() {
    const { tcId, testingEventId, currentRequest } = this.props;
    await this.props.actions.updateRequest({
      testCenterId: tcId,
      testingEventId: testingEventId,
      status: REQUEST_UPDATE_STATUS.cancelled,
    });
    this.setState({
      cancelModalOpen: false,
      showAlertMessage: true,
      alertMessage: getAlertMessage(currentRequest.type),
    });
    this.props.actions.getRequestUpdate(tcId, testingEventId);
  }

  removeAlertMessage() {
    this.setState({
      showAlertMessage: false,
      alertMessage: '',
    });
  }

  renderRequest(currentRequest) {
    const { locations, capacityTypes } = this.props;

    switch (currentRequest.type) {
      case REQUEST_UPDATE_TYPE.eventUpdate:
        return (
          currentRequest.data &&
          currentRequest.data.eventUpdate && (
            <ReviewEventUpdates
              eventUpdate={currentRequest.data.eventUpdate}
              locations={locations}
              capacityNames={mapCapacityTypes(capacityTypes)}
            />
          )
        );
      case REQUEST_UPDATE_TYPE.closeTcEvent:
        return (
          currentRequest.data &&
          currentRequest.data.eventClose && (
            <ReviewCloseTC eventClose={currentRequest.data.eventClose} />
          )
        );
      case REQUEST_UPDATE_TYPE.rescheduleTcEvent:
        return (
          currentRequest.data &&
          currentRequest.data.eventReschedule && (
            <ReviewRescheduleTC eventReschedule={currentRequest.data.eventReschedule} />
          )
        );
      default:
        return '';
    }
  }

  render() {
    const { cancelModalOpen, showAlertMessage, alertMessage } = this.state;

    const { currentRequest, errorUpdateRequest } = this.props;

    return (
      <div className="cancel-request-section">
        {currentRequest && !isEmpty(currentRequest) && (
          <React.Fragment>
            <button className="btn-link cancel-button" onClick={() => this.toggleCancelModal()}>
              <CloseCircle className="show-mobile" />
              <span className="pe-1">
                {this.props.t('requestUpdate.cancelRequest.buttonLabel')}
              </span>
              <CloseCircle className="hide-mobile" />
            </button>

            <ModalInfo
              containerClass="modal-cancel-request-container"
              className="modal-cancel-request"
              modalIsOpen={cancelModalOpen}
              closeModal={() => this.toggleCancelModal()}
              onSubmit={this.onCancelRequest}
              headerTitle={this.props.t('requestUpdate.title')}
              saveLabel={this.props.t('requestUpdate.cancelRequest.buttonLabel')}
              cancelLabel={this.props.t('common.labels.back')}
              showCancel>
              <h4>{this.props.t('requestUpdate.cancelRequest.subtitle')}</h4>
              <AlertNotice message={this.props.t('requestUpdate.cancelRequest.infoMessage')} />
              {this.renderRequest(currentRequest)}
            </ModalInfo>
          </React.Fragment>
        )}
        <AlertMessage
          show={showAlertMessage}
          removeMessage={this.removeAlertMessage}
          message={errorUpdateRequest ? 'errors.somethingWentWrong' : alertMessage}
          isError={errorUpdateRequest}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentRequest: state.requestUpdate.currentRequest,
    errorUpdateRequest: state.requestUpdate.errorUpdateRequest,
    capacityTypes: filterCapacityTypesByUnlimited(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ ...requestUpdateActions }, dispatch) };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CancelRequestUpdate));

const ReviewEventUpdates = ({ eventUpdate, locations, capacityNames }) => {
  const { t } = useTranslation();
  return (
    <div className="review-section">
      {!isEmpty(eventUpdate.locationEvents) && (
        <>
          <div className="subtitle">{t('requestUpdate.capacityTab')}</div>
          {eventUpdate.locationEvents.map((locationCapacities) => {
            const location = find(locations, { id: locationCapacities.locationId });
            return (
              <div
                className="location"
                key={`location-capacities-${locationCapacities.locationId}`}>
                <div className="location-title">
                  <BuildingIcon />
                  <span className="fw-bold">
                    {location.name}{' '}
                    {location.area && location.area.length > 0 && `, ${location.area}`}
                  </span>
                  {locationCapacities.status &&
                    location.locationEvent.status !== locationCapacities.status.toUpperCase() && (
                      <>
                        <span> - </span>{' '}
                        <span className="is-updated fw-normal">
                          {t(
                            locationCapacities.status &&
                              locationCapacities.status.toUpperCase() ===
                                LOCATION_EVENT_STATUS.closed
                              ? 'requestUpdate.review.locationClosed'
                              : 'requestUpdate.review.locationOpened'
                          )}
                        </span>
                      </>
                    )}
                </div>
                {locationCapacities.capacities &&
                  locationCapacities.capacities.map((capacityType) => (
                    <div className="fw-bold" key={`capacity-type-${capacityType.capacityTypeId}`}>
                      {capacityNames[capacityType.capacityTypeId]} -{' '}
                      <span className="is-updated">
                        {t('requestUpdate.review.newCapacityLabel')}
                      </span>
                      : <span className="is-updated fw-normal">{capacityType.capacity}</span>
                    </div>
                  ))}
              </div>
            );
          })}
        </>
      )}

      {!isUndefined(eventUpdate.message) && (
        <>
          <div className="subtitle">{t('requestUpdate.admissionTab')}</div>
          {eventUpdate.message ? (
            <div className="is-updated">
              <div className="fw-bold">{t('requestUpdate.review.newMessage')}</div>
              <div>{eventUpdate.message}</div>
            </div>
          ) : (
            <div className="is-updated fw-bold">{t('requestUpdate.review.deletedMessage')}</div>
          )}
        </>
      )}

      {!isEmpty(eventUpdate.shippingAddress) && (
        <>
          <div className="subtitle">{t('requestUpdate.shippingTab')}</div>
          {Object.entries(SHIPPING_LABELS).map((item) => {
            const [key, value] = item;
            return (
              eventUpdate.shippingAddress[key] && (
                <div className="is-updated" key={key}>
                  <div className="fw-bold">{t(value)}</div>
                  <div>
                    {isArray(eventUpdate.shippingAddress[key])
                      ? eventUpdate.shippingAddress[key].map((item) => (
                          <div key={`key-${item}`}>{item}</div>
                        ))
                      : eventUpdate.shippingAddress[key]}
                  </div>
                </div>
              )
            );
          })}
        </>
      )}
    </div>
  );
};

const ReviewCloseTC = ({ eventClose }) => {
  const { t } = useTranslation();
  return (
    <div className="review-section">
      <div className="subtitle">{t('requestUpdate.closeTCOption')}</div>
      <div className="is-updated">
        <div className="fw-bold">{t('requestUpdate.closeTcModal.reasonLabel')}</div>
        <div>
          {eventClose.reason ? eventClose.reason : t('requestUpdate.closeTcModal.noReasonMessage')}
        </div>
      </div>
    </div>
  );
};

CancelRequestUpdate.propTypes = {
  t: PropTypes.func.isRequired,
};

CancelRequestUpdate.defaultProps = {};
